import Cookies from 'js-cookie'

const TokenKey = 'tk'
// 当前页标题
const currentTitleKey='currentTitle'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token,expireDate) {
  return Cookies.set(TokenKey, token, {
    expires: expireDate
  })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setCurrentTitle(currentTitle,expireDate) {
  return Cookies.set(currentTitleKey, currentTitle, {
    expires: expireDate
  })
}

export function getCurrentTitle() {
  return Cookies.get(currentTitleKey)
}